import {DataFetcher, PriorityConfig} from '@aboutyou/data-fetcher';
import {GetSearchResultsPageBulkResponse_NavigationHeader} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/search/v1/service.types';
import {usePathname} from '@aboutyou/router';
import React from 'react';
import {CategorySlider} from '../../../features/CategorySlider/CategorySlider';
import {CategorySliderLoading} from '../../../features/CategorySlider/CategorySliderLoading';
import {useAppliedPotentialFilters} from '../../../features/ProductStream/utils';
import {useMergedPath} from '../../../shared-deprecated/useMergedPath';
import {useCategoryIdentifier} from '../hooks/useCategoryIdentifier';
import {useSearchNavigationHeaderSection} from '../hooks/useSearchPageBulkSection';

export const SearchCategorySlider: React.FC<PriorityConfig> = ({
  renderingPriority,
}) => {
  return (
    <DataFetcher
      request={useSearchNavigationHeaderSection()}
      Error={null}
      Loading={CategorySliderLoading}
      View={SearchCategorySliderView}
      renderingPriority={renderingPriority}
    />
  );
};

const SearchCategorySliderView: React.FC<
  GetSearchResultsPageBulkResponse_NavigationHeader
> = ({categories, ...otherProps}) => {
  const categoryIdentifier = useCategoryIdentifier();
  const getMergedPath = useMergedPath();
  const pathname = usePathname();
  const hasAppliedFilters = Boolean(
    Object.keys(useAppliedPotentialFilters()).length,
  );

  return (
    <CategorySlider
      activeCategoryId={categoryIdentifier?.identifier.id}
      categories={categories.map(({category, hasProducts}) => ({
        category,
        hasProducts,
        // Use useMergedPath to merge category=id into current URL, preserving other params like term and filters
        targetPath: getMergedPath({
          path: `${pathname}?category=${category.id}`,
          config: {excludeUrlParams: new Set(['category', 'path'])},
        }),
      }))}
      useButtonLink={hasAppliedFilters}
      {...otherProps}
    />
  );
};
